import { Button, UIHeading2 } from '@cian/ui-kit';

import { FC } from 'react';

import styles from './MapError.css';

type MapErrorProps = {
  errorMessage: string;
  onRetry?: VoidFunction;
};

export const MapError: FC<MapErrorProps> = props => {
  const { errorMessage, onRetry } = props;

  return (
    <article className={styles['container']}>
      <section className={styles['header']}>
        <UIHeading2 as="h2">{errorMessage}</UIHeading2>
      </section>
      {onRetry && (
        <Button size="M" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </article>
  );
};
